<template>
    <div v-if="filterText" class="mt-6 mb-3 text-center">
        <div class="subtitle-2">
            <v-img src="img/not-found.jpg" :class="{'rounded-circle': isDark}" class="w-50 text-center mx-auto" max-width="250" :gradient="isDark ? 'to top right, rgb(148, 156, 162, .1), rgb(148, 156, 162, .3)' : ''" />
            <div class="my-6">{{ message }}</div>
        </div>
    </div>
</template>

<script>
import MixinDark from "@/mixins/database/MixinDark";

export default {
    name: "device-no-apps-found",
    mixins: [MixinDark],
    props: {
        filterText: {
            type: String,
            required: true,
        }
    },
    computed: {
        message() {
            return this.$gettextInterpolate(this.$gettext('Sorry, no apps match your search: %{search}'), {
                search: this.filterText
            })
        },
    }
}
</script>
<style scoped type="text/scss">
.w-50{
    width: 50%;
}
</style>
